import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { User } from 'app/shared/types/user';
import { UserService } from 'app/shared/services/user.service';
import { EmployeeService } from 'app/shared/services/employee.service';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { AuthService } from 'app/shared/services/auth.service';
import { map, startWith } from 'rxjs/operators';
import { Observable} from 'rxjs';
import { Router} from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';




@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {


  user: User;
  userTypeList: any[];
  userForm: FormGroup;
  showProcessingIndicator = false;
  isEmpIdReadOnly : boolean= true;
  isReadOnly : boolean= true;
  panelTitle ="New User"

  filteredOptions: Observable<any[]>;
  employeeList :any[]=[];


  validationMessages = {
    'empId': { 'required': 'Employee Id name is required' },
    'empName': { 'required': 'Employee name is required' },
    'username': { 'required': 'User Name is required' },
    'password': { 'required': 'Password is required' },
    'userType': { 'required': 'User Type is required' },
  };

  formErrors = {
    'empId': "",
    'empName': "",
    'username': "",
    'password': "",
    'userType': "",
  };



  constructor(private fb: FormBuilder,
    private userService: UserService,
    private toastr: ToastrService,
    private dialogService: DialogService,
    private authService: AuthService,
    private router : Router,
    private employeeService : EmployeeService,
    public dialogRef: MatDialogRef<UsersComponent>
   
  ) { }

  ngOnInit(): void {

    this.getUserTypeList();
    this.getEmployeeList();
    this.initUserType();
    this.initFormFields();

    this.getTableRowData();
    this.autoComplete();


  } // end Oninit

  autoComplete(){
    this.filteredOptions = this.userForm.get('empName').valueChanges
    .pipe(
     startWith(''),
     map(value => this._filter(value))
    );
  
  
  }


  private _filter(empName: string): any[] {
    if(empName){
       const filterValue = empName.toLowerCase();
       return this.employeeList.filter(option => option.EmpName.toLowerCase().indexOf(filterValue) === 0);
    }
  }


  getEmployeeData(){
    var filteredData;
    var empName = this.userForm.value.empName;
    if(empName){
    filteredData = this.employeeList.filter(data =>data.EmpName.toLowerCase()===empName.toLowerCase());
     if(filteredData.length ===1){
       this.userForm.patchValue({
         empId : filteredData[0].EmpId
       });
     }else{
      this.userForm.patchValue({
        empId : null,
      });
     }
    }
   }

   getEmployeeList(){
    this.employeeService.getAll()
     .subscribe(
        (data) => {
                  this.employeeList= data;                
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }

  initUserType(){
    this.user = {
      id: null,
      empId: '',
      empName: '',
      username: '',
      password: '',
      userType: '',
      status: '',
      createdBy: '',

    }
  }

  initFormFields(){
    this.userForm = this.fb.group({
      id: [null],
      empId: [''],
      empName: ['', Validators.required],
      username: ['', Validators.required],
      password: ['', Validators.required],
      userType: ['', Validators.required],
      status: [''],
      createdBy: [''],

    });

  }

  getUserTypeList(){
    this.userService.getAllUserTypes()
     .subscribe(
        (data) => {
                  this.userTypeList = data;
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }



 newButtonClick(): void {
    this.panelTitle ="New User";
    this.isReadOnly = false;
    this.enableForm();
    this.userForm.reset();
    this.resetValiationErrors();

   }

   onClose(){
    this.userForm.reset();
    this.dialogRef.close();
   }



  saveButtonClick(): void {
    var data: any;
    
    this.logValidationErrors(this.userForm, true);
    this.mapFormValuesToModel();

    if (this.isFilledFromFields()) {

      if (!this.userForm.value.id) {
        this.showProcessingIndicator = true;
        this.userService.addUser(this.user)
          .subscribe(
            (res) => {
              data = res;
              if(data.success === 0){
                this.toastr.error('This user name already exist. make sure to enter unique user name', 'warning');
                this.showProcessingIndicator = false;
              }else if(data.success === 1){
                this.toastr.success('User  added successfully', 'Success');               
                this.showProcessingIndicator = false;   
                this.onClose(); 
              }
                
            },
            (err) => {
              this.toastr.error('Failed to add user', 'Failure');
              this.showProcessingIndicator = false;
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            },
          )



      } else {
        this.dialogService.openConfirmDialog('Are you sure you want to update this record?')
          .afterClosed().subscribe(res => {
            if (res) {
              this.showProcessingIndicator = true;
              this.userService.updateUser(this.user)
                .subscribe(
                  (res) => {
                    this.toastr.success('User updated successfully', 'Success');
                    console.log(res);
                    this.showProcessingIndicator = false;
                    this.onClose(); 
                  },
                  (err) => {
                    this.toastr.error('Failed to update user', 'Failure');
                    this.showProcessingIndicator = false;
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  },
                )

            } else {
              this.showProcessingIndicator = false;
            }
          })

      }

    }
    else {
      this.toastr.warning('Required Fields cannot be empty or invalid.', 'Error Message');
      this.showProcessingIndicator = false;

    }


  }


  enableForm(): void {
    Object.keys(this.userForm.controls).forEach(key => {
      this.userForm.controls[key].enable();
     // console.log(key)
    });
  }



  resetValiationErrors(){
    Object.keys(this.userForm.controls).forEach(key => {
      this.userForm.get(key).setErrors(null) ;
    });
  }

  logValidationErrors(group: FormGroup = this.userForm, isDirty: boolean = false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (isDirty) {
        this.enableForm();
        this.userForm.controls[key].markAsTouched();
      }
      if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.validationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });
  }


  isFilledFromFields(): boolean {

    var value = this.userForm.value.empId;
    if(!value){
      this.userForm.patchValue({ empId :  null,empName :  null });    
    }

    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
        return false;
    }
    return true;
  }

  mapFormValuesToModel() {
    this.user.id = this.userForm.value.id;
    this.user.empId = this.userForm.value.empId;
    this.user.empName = this.userForm.value.empName;
    this.user.username = this.userForm.value.username;
    this.user.password = this.userForm.value.password;
    this.user.userType = this.userForm.value.userType;
    if(this.userForm.value.status){
      this.user.status='Deactivated';    
    }
    else{
      this.user.status='Active';
    } 
    this.user.createdBy = this.authService.getUserLoggedIn();

  }



  getTableRowData() {
    var activeStatus = false;
    var data = this.userService.dataRow;
    if (data) {
      this.panelTitle ="View User"
      if(data.Status=='Active'){
        activeStatus = false;
      }else{
        activeStatus = true;
      }

      this.userForm.patchValue({
        id: data.Id,
        empId: data.EmpId,
        empName: data.EmpName,
        username: data.UserName,
        password: data.Password,
        userType: data.UserType,
        status : activeStatus, 
  
      });
      this.isReadOnly = true;
    }else{
      this.newButtonClick();
    }


  }





}// end class
